import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

// Self-hosted brand fonts — bundled by Vite, no CDN at runtime.
import "@fontsource/archivo/400.css";
import "@fontsource/archivo/500.css";
import "@fontsource/archivo/600.css";
import "@fontsource/archivo/700.css";
import "@fontsource/jetbrains-mono/400.css";
import "@fontsource/jetbrains-mono/500.css";
import "@fontsource/jetbrains-mono/600.css";

import { ApiProvider } from "./api/ApiProvider";
import { App } from "./App";
import { SessionProvider } from "./auth/SessionProvider";
import "./styles/tokens.css";
import "./styles/app.css";

const container = document.getElementById("root");
if (!container) {
  throw new Error("The #root element is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <BrowserRouter>
      <ApiProvider>
        <SessionProvider>
          <App />
        </SessionProvider>
      </ApiProvider>
    </BrowserRouter>
  </StrictMode>,
);
